// DateFilterTemplate.js
import { Calendar } from "primereact/calendar"
import React from "react"

export default function DateFilterTemplate({ value, filterCallback, index }) {
  const currentYear = new Date().getFullYear()
  const yearRange = `1900:${currentYear + 5}`

  return (
    <Calendar
      value={value}
      onChange={(e) => filterCallback(e.value, index)}
      dateFormat="MM/dd/yy"
      placeholder="MM/dd/yyyy"
      mask="99/99/9999"
      yearNavigator
      yearRange={yearRange}
      monthNavigator
      showIcon
    />
  )
}
